import React from 'react';

export interface CommandItemProps {
  label: string;
  kind: 'command' | 'ai';
  active: boolean;
  onClick: () => void;
}

export const CommandItem: React.FC<CommandItemProps> = ({ label, kind, active, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={`palette-item-${kind}`}
    style={{
      display: 'block',
      width: '100%',
      textAlign: 'left',
      padding: '8px 14px',
      border: 'none',
      background: active ? 'rgba(139,92,246,0.12)' : 'transparent',
      cursor: 'pointer',
      fontSize: 13,
    }}
  >
    {kind === 'ai' && <span style={{ background: '#8b5cf6', color: 'white', fontSize: 10, padding: '1px 6px', borderRadius: 3, marginRight: 8 }}>AI</span>}
    {label}
  </button>
);
